import { render, staticRenderFns } from "./WorkingoutExercise.vue?vue&type=template&id=3491b8b8&scoped=true&xmlns=true"
import script from "./WorkingoutExercise.vue?vue&type=script&lang=js"
export * from "./WorkingoutExercise.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutExercise.vue?vue&type=style&index=0&id=3491b8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491b8b8",
  null
  
)

export default component.exports